import PropTypes from 'prop-types';
import { memo } from 'react';

import Breadcrumb from 'shopper/components/Breadcrumb/V1/Breadcrumb';

import BreadcrumbItem from 'components/Breadcrumb/Item';

import { toThreadCategoryLink } from 'lib/links';
import placeholder from 'lib/placeholder';

import LINKS from 'constants/links';

const ThreadHeading = ({
  threadCategoryName,
  threadCategorySlug,
  threadTitle,
}) => (
  <div className="mx-4 lg:mx-0">
    <Breadcrumb>
      <BreadcrumbItem href={LINKS.HOME}>
        {placeholder('breadcrumbs.app')}
      </BreadcrumbItem>
      <BreadcrumbItem href={LINKS.FORUM}>
        {placeholder('breadcrumbs.forum')}
      </BreadcrumbItem>
      {threadCategoryName && (
        <BreadcrumbItem href={toThreadCategoryLink(threadCategorySlug)}>
          {threadCategoryName}
        </BreadcrumbItem>
      )}
      <BreadcrumbItem>{threadTitle}</BreadcrumbItem>
    </Breadcrumb>
  </div>
);

ThreadHeading.propTypes = {
  threadCategoryName: PropTypes.string.isRequired,
  threadCategorySlug: PropTypes.string.isRequired,
  threadTitle: PropTypes.string.isRequired,
};

export default memo(ThreadHeading);
